import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store/indexRedux";
import { fetchContractStatuses, SdpStatusEntry, StatusDirection } from "../api/contractStatus";

const DIRECTIONS: StatusDirection[] = ["injection", "offtake", "flex"];

/**
 * FT-1189 ④ — per-SDP contract statuses for the selected company, keyed by
 * installation_id. Failure of any direction degrades gracefully to an empty
 * map slice: consumers fall back to their legacy status source.
 */
export function useContractStatuses(companyId: number | null | undefined) {
  const accessToken = useSelector((state: RootState) => state.authv2.accessToken);
  const [statuses, setStatuses] = useState<Map<string, SdpStatusEntry>>(new Map());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!companyId || !accessToken) {
      setStatuses(new Map());
      return;
    }
    let cancelled = false;
    setLoading(true);

    Promise.allSettled(DIRECTIONS.map((direction) => fetchContractStatuses(companyId, direction, accessToken)))
      .then((results) => {
        if (cancelled) return;
        const map = new Map<string, SdpStatusEntry>();
        for (const result of results) {
          if (result.status !== "fulfilled") continue;
          for (const sdp of result.value) {
            map.set(sdp.installation_id, sdp);
          }
        }
        setStatuses(map);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [companyId, accessToken]);

  return { statuses, loading };
}
